import React from "react";
import classes from "./Slide.module.css";
import Container from "../../../UI/Container/Container";

const Slide = (props) => {
  let classArr = [classes.Slide];
  let ariaHidden = true;

  if (props.active) {
    classArr = [classes.Slide, classes.Active];
    ariaHidden = !props.active
  }

  return (
    <div className={classArr.join(" ")} aria-hidden={ariaHidden}>
      <img src={props.img} alt={props.alt} />
      <div className={classes.Content}>
        <Container>
          <h2>{props.headline}</h2>
          <p>{props.description}</p>
        </Container>
      </div>
    </div>
  );
};

export default Slide;
